import React, { ButtonHTMLAttributes, DetailedHTMLProps, FunctionComponent, PropsWithChildren } from 'react';
import { Icon } from '../Icon/Icon';

import './Button.scss';

export const Button: FunctionComponent<
    PropsWithChildren<
        DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
            mirror?: boolean;
            icon?: string;
        }
    >
> = (props) => {
    // make sure only valid props are spread to ``button`` element
    const { mirror, className, children, ...buttonProps } = props;
    return (
        <button
            {...buttonProps}
            className={[
                'shopping-planner-button',
                props.mirror ? 'shopping-planner-button--mirror' : '',
                props.className ?? '',
            ].join(' ')}
        >
            <span>{props.children}</span>
            {props.icon ? <Icon icon={props.icon} /> : null}
        </button>
    );
};
